export interface OutsideClickSubject {
    elementClass: string,
    clickOutside: () => any,
}

export class OutsideClickClass {
    private static subjects: OutsideClickSubject[] = []
    private static listeningOutside = false;

    constructor() {
    }

    /**
     * Listen to body clicks
     */
    private static listenOutside(): void {
        if (OutsideClickClass.subjects.length === 0 || OutsideClickClass.listeningOutside) {
            return;
        }

        OutsideClickClass.listeningOutside = true;
        document.body.addEventListener('click', ev => this.onClickSomewhere(ev));
    }

    /**
     * User clicked somewhere on the page
     * @param e
     * @private
     */
    private static onClickSomewhere(e: Event): void {
        const clickedEl: HTMLElement = e.target as HTMLElement;

        OutsideClickClass.subjects.forEach(subject => {
            if (!clickedEl.closest(subject.elementClass)) {
                subject.clickOutside();
                this.removeElement(subject.elementClass);
            }
        })
    }

    /**
     * Add an element to listen for outside click
     * @param elementClass the element className that we have to listen for outside click
     * @param callback called when outside click on element
     */
    static addElement(elementClass: string, callback: () => void): void {

        //add a 200ms timeout to avoid same click & click outside
        setTimeout(() => {
            if (!OutsideClickClass.subjects.some(subject => subject.elementClass === elementClass)) {
                OutsideClickClass.subjects.push({
                    elementClass,
                    clickOutside: callback
                });
            }

            this.listenOutside();
        }, 200);
    }

    /**
     * Remove an element from the listen table
     * @param elementClass
     * @protected
     */
    static removeElement(elementClass: string): void {
        OutsideClickClass.subjects.splice(OutsideClickClass.subjects.findIndex(subject => subject.elementClass === elementClass), 1);
    }

}
